import { BadgeProps } from "@made-people/blueprint-badge";

export const Badge: BadgeProps = {
  variants: {
    color: "black",
    size: "lg",
  },
};
